import React from "react";
import { Select, SelectItem } from "@heroui/react";
import { Icon } from "@iconify/react";

const MonthSelect = ({
    label,
    value,
    onChange,
    isReadOnly = false,
    className = "max-w-xs",
    icon = "lucide:calendar",
    ...props
}) => {
    // Array de meses en español
    const months = [
        { key: "1", label: "Enero" },
        { key: "2", label: "Febrero" },
        { key: "3", label: "Marzo" },
        { key: "4", label: "Abril" },
        { key: "5", label: "Mayo" },
        { key: "6", label: "Junio" },
        { key: "7", label: "Julio" },
        { key: "8", label: "Agosto" },
        { key: "9", label: "Septiembre" },
        { key: "10", label: "Octubre" },
        { key: "11", label: "Noviembre" },
        { key: "12", label: "Diciembre" },
    ];

    // Manejador de cambio - HeroUI Select pasa un Set con las claves seleccionadas
    const handleSelectionChange = (keys) => {
        if (onChange) {
            // Convertir el Set a un array y tomar el primer valor
            const selectedKey = Array.from(keys)[0];
            onChange(selectedKey || "");
        }
    };

    return (
        <Select
            label={label}
            placeholder={label}
            selectedKeys={value ? [value.toString()] : []}
            onSelectionChange={handleSelectionChange}
            isDisabled={isReadOnly}
            startContent={
                <Icon
                    icon={icon}
                    className="text-default-400 pointer-events-none flex-shrink-0"
                />
            }
            classNames={{
                label: "text-sm font-medium",
                trigger: "text-sm",
            }}
            className={className}
            {...props}
        >
            {months.map((month) => (
                <SelectItem key={month.key}>
                    {month.label}
                </SelectItem>
            ))}
        </Select>
    );
};

export default MonthSelect; 